import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const CourseTop = styled.div`
    display:flex;
    align-items: center;
    height:50px;
`;

export const ShowCourses = styled.button`
    margin-left: auto;
    background: ${props => props.theme.colors.placeholderColor};
    font-size: 16px;
    color:#fff;
    border-radius:20px;
    padding:6px 24px;
    transition: all 0.2s ease-in-out;

    :hover{
        background: ${props => props.theme.colors.buttonHoverColor}
    }
`;

export const Content = styled.div`
    position: relative;
    display:grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap:20px 30px;
    min-height: 131px;

    ${mq(Devices.custom1300)}{
        grid-template-columns: 1fr 1fr;
        gap:14px 30px;
    }

    ${mq(Devices.tablet)}{
        grid-template-columns: 1fr;
        gap:14px 30px;
    }
`;

export const Course = styled.div<{admin?:boolean}>`
    display:grid;
    grid-template-columns: 1fr 120px;
    height:132px;
    border-radius: 10px;
    overflow: hidden;
    cursor: ${props => props.admin?"pointer":"default"};

    ${mq(Devices.mobile)}{
        grid-template-columns: 1fr 80px;
        height:82px;
    }
`;

export const CoursePending = styled.div`
    position: relative;
    height:132px;
    border-radius: 10px;
    overflow: hidden;
    background: rgba(255,255,255,0.6);

    ${mq(Devices.mobile)}{
        height:82px;
    }
`;

export const CourseContentWrapper = styled.div`
    position: relative;
    background:#fff;
    overflow: hidden;
`;

export const CourseContent = styled.div`
    
    height:100%;
    position: relative;
    z-index: 2;

    span{
        font-size: 14px;
        padding:14px;
        position: absolute;
    }

    span:nth-of-type(1){
        font-size: 16px;
        font-weight: 500;
    }

    span:nth-of-type(2){
        right:0;
    }
    span:nth-of-type(3){
        font-size: 14px;
        bottom:0;
    }
    span:nth-of-type(4){
        right:0;
        bottom:0;
    }

    ${mq(Devices.mobile)}{
        span{
            font-size: clamp(12px, 4vw , 16px) !important;
            padding:10px;
        }
        span:nth-of-type(1){
            font-weight: 500;
        }
    }
`;

export const Chart = styled.div`

`;

export const CoursePercentage = styled.div<{backgroundColor?:string}>`
    display:flex;
    background: ${props => props.backgroundColor?props.backgroundColor:"#959595"};
    align-items: center;
    justify-content: center;

    span{
        font-size: 30px;
        color:#fff;
        font-weight: 800;
    }

    ${mq(Devices.mobile)}{
        span{
            font-size: clamp(18px, 4vw , 30px);
        }
    }
`;